import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

// Extend Window interface to include React
declare global {
  interface Window {
    React: typeof React;
    __APP_VERSION__?: string;
  }
}

// Ensure React is available globally for Radix UI components
if (typeof window !== 'undefined') {
  window.React = React;
}

import { QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from '@/lib/query-client';

import { RouterProvider, createRouter } from '@tanstack/react-router';
// import { AnalyticsConsent } from './components/analytics-consent';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles/index.css';

// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
          {/* <ReactQueryDevtools initialIsOpen={false} /> */}
          {/* <AnalyticsConsent /> */}
        </QueryClientProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}
